// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDgrVwgswxqsFsvyNVGC7MAPm2xdBtRTHo",
  authDomain: "rahal-7e911.firebaseapp.com",
  databaseURL: "https://rahal-7e911-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "rahal-7e911",
  storageBucket: "rahal-7e911.appspot.com",
  messagingSenderId: "288521883799",
  appId: "1:288521883799:web:73ce74e2d781965ed319d2",
  measurementId: "G-7ZN6XV11P7"
};
const REGION = 'europe-west1'

// Cloud Functions
const backendUrl = `https://${REGION}-${
  firebaseConfig.projectId
}.cloudfunctions.net/api`;

// App Engine
// const backendUrl = `https://${REGION}-saryah-31e36.cloudfunctions.net/api`;

export default {
  firebaseConfig,
  backendUrl,
};

